import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const getInitials = (name) => {
  if (!name) return "U";

  return String(name)
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase())
    .join("")
    .slice(0, 2);
};

const getRankLabel = (rank) => {
  if (rank === undefined || rank === null) return "Quotation not submitted";
  return rank;
};

const getRankTitle = (rank) =>
  rank === undefined || rank === null
    ? "Quotation rank is available after quotation submission"
    : "Based on your submitted quotation";

const QuotationTopNav = ({ showRank = false, currentRank }) => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const business = useSelector((state) => state.business);

  const user = auth?.user;
  const userType = user?.userType || user?.userProfile?.userType;
  const hasBusiness = business?.profile?.isActive;
  const showVendorActions = userType === "vendor" || (userType === "buyer" && hasBusiness);

  return (
    <header className="sticky top-0 z-40 flex w-full items-center justify-between overflow-hidden border-b border-[#E8E3D9] bg-white px-4 py-2 shadow-sm lg:px-8">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#FFF0E4] via-white to-[#E4E7FF]" />
      <div className="pointer-events-none absolute -left-6 -top-8 h-16 w-16 rounded-full bg-[#FD6600]/10 blur-sm" />
      <div className="pointer-events-none absolute right-10 -top-8 h-20 w-32 rounded-full bg-[#185FA5]/10 blur-md lg:right-32" />
      <div className="pointer-events-none absolute bottom-0 right-1/2 h-5 w-28 rounded-t-full bg-[#FD6600]/5" />

      <button type="button" aria-label="Neevay home" className="relative z-10">
        <img
          src="https://storagereponeevaydevcdn.blob.core.windows.net/business/homepage_4_neevayLogo.svg"
          className="h-8 w-auto lg:h-7"
          alt="Neevay"
        />
      </button>

      <nav className="relative z-10 flex items-center gap-2 lg:gap-3">
        {showVendorActions && (
          <>
            <button
              type="button"
              onClick={() => navigate("/leads")}
              className="rounded-full border border-[#D8D8C8] px-2.5 py-1.5 text-[11px] font-semibold text-[#303026] hover:bg-[#F7F7EF] lg:px-4 lg:py-2 lg:text-xs"
            >
              My Leads
            </button>
            <button
              type="button"
              onClick={() => navigate("/my-business")}
              className="rounded-full border border-[#D8D8C8] px-2.5 py-1.5 text-[11px] font-semibold text-[#303026] hover:bg-[#F7F7EF] lg:px-4 lg:py-2 lg:text-xs"
            >
              My Business
            </button>
          </>
        )}

        {showRank && (
          <div
            className="flex items-center gap-2 rounded-full border border-[#DDEFD9] bg-white/85 px-3 py-1.5 text-xs font-semibold text-[#303026] shadow-sm"
            title={getRankTitle(currentRank)}
          >
            <span className="relative flex h-4 w-4 items-center justify-center">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-lime-500 opacity-40"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-lime-500"></span>
            </span>
            <span className="hidden text-[#737373] sm:inline">Quotation Rank:</span>
            <span className="font-bold text-black">{getRankLabel(currentRank)}</span>
          </div>
        )}
        <button
          type="button"
          onClick={() => navigate("/my-profile")}
          className="flex items-center gap-2 px-1 py-1 text-xs font-semibold text-[#303026] hover:bg-[#F7F7EF] lg:px-2 lg:pr-3"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#1D4ED8] text-xs font-semibold text-white lg:text-sm">
            {getInitials(user?.name)}
          </span>
          {/* My Profile */}
        </button>
      </nav>
    </header>
  );
};

export default QuotationTopNav;
